const Component = ({ classNames, label, value  }) => {
  return <div className={`text-center rounded-md pt-3 pb-3 bg-chCard-background ${classNames?.wrapper || ''}`}>
    <div className={`text-base md:text-2xl text-statValue font-bold ${classNames?.value || ''}`}>{value}</div>
    <div className={`text-sm md:text-base text-statLabel ${classNames?.label}`}>{label}</div>
  </div>
}

export default Component
